module.exports = __webpack_public_path__ + "img/university-list-bannerImg.84a443a1.jpg";